import { computed } from "vue";
import { useAuthorization } from "@sttedra_ui/framework";

const { modelRef: authorizationModelRef } = useAuthorization();

export default class AppViewState {
  roles = computed(() => {
    return authorizationModelRef._value?.roles == undefined ||
      Object.keys(authorizationModelRef._value?.roles).length === 0
      ? null
      : authorizationModelRef._value?.roles.join(", ");
  });
}
